module.exports = __webpack_public_path__ + "img/JLTP_content_N3.39dce07e.svg";